namespace $ { $mol_style_attach( "optimade/zero/search/search.view.css",
 "[optimade_zero_search_filters_page] {\n\twidth: 400px;\n}\n"
) }